/**
 * コレクションページの URL から sort_by=manual を除去（クエリに残さない）。
 * 管理画面の並び順はそのまま。manual は URL に出さない。
 */
(function () {
  try {
    var u = new URL(window.location.href);
    if (!/^\/collections\/[^/]+\/?$/.test(u.pathname) && u.pathname !== "/collections/all") {
      return;
    }
    if (u.searchParams.get("sort_by") !== "manual") {
      return;
    }
    u.searchParams.delete("sort_by");
    var qs = u.searchParams.toString();
    window.location.replace(u.pathname + (qs ? "?" + qs : "") + u.hash);
  } catch (e) {}
})();
